import { render, staticRenderFns } from "./HeaderFolderButtons.vue?vue&type=template&id=8c8aff34"
import script from "./HeaderFolderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderFolderButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c8aff34')) {
      api.createRecord('8c8aff34', component.options)
    } else {
      api.reload('8c8aff34', component.options)
    }
    module.hot.accept("./HeaderFolderButtons.vue?vue&type=template&id=8c8aff34", function () {
      api.rerender('8c8aff34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderFolderButtons.vue"
export default component.exports